import { useMemo } from 'react';
import { toMediaUrl } from '../Services/ApiService';
import { ServerEndpoint } from '../Redux/endpoints.ts';

/**
 * Resolves an image URL through our own media route (which proxies the Lambda
 * image optimizer). Handles both the stored site-relative form (/media/...) and
 * legacy raw S3 URLs (rewritten via toMediaUrl). Serving media from our domain
 * lets Google index the images under the site instead of under amazonaws.com.
 * External URLs (Zoho, CDNs, data URIs, etc.) are returned unchanged.
 */
const useLambdaImage = (src, width, quality = 75) => {
    return useMemo(() => {
        // Guard non-string src (objects/numbers) so we never call .startsWith on them.
        if (!src || typeof src !== 'string') return '';

        const mediaUrl = toMediaUrl(src);
        const isOurMedia = mediaUrl !== src || src.startsWith(`/${ServerEndpoint.MEDIA}/`);
        if (!isOurMedia) return src; // external / non-S3 URL — pass through

        const params = [];
        if (width)   params.push(`w=${width}`);
        if (quality) params.push(`q=${quality}`);
        return params.length ? `${mediaUrl}?${params.join('&')}` : mediaUrl;
    }, [src, width, quality]);
};

export default useLambdaImage;
